import DeliverablePackageCard from "@entities/brief/ui/Influencer/v2/DeliverablePackageCard";
import { IBrief } from "@shared/lib/types/brief";
import { IBriefDeliverable } from "@shared/lib/types/briefInfluencerV2";
import styles from "./styles.module.scss";

export function Deliverables({
  deliverable,
  briefId,
  brief,
}: {
  deliverable?: IBriefDeliverable;
  briefId: string;
  brief?: IBrief;
}) {
  if (!deliverable) return <div>No Deliverables</div>;

  return (
    <div>
      <div className={styles.sectionTitle}>Deliverables</div>
      <DeliverablePackageCard
        deliverableId={deliverable?._id || ""}
        briefId={briefId}
        defaultDeliverableId={brief?.defaultDeliverableV2Id}
      />
    </div>
  );
}
